// socketManager.js
import { io } from "socket.io-client";
import { setConnected, setDisconnected, flushEvents } from "./socketSlice";
import { store } from "./store";


let socket;

export const initSocket = (dispatch) => {
    if (socket) return socket;
    console.log(`socket initializing...`);
    socket = io("https://bima-essentials.com", {
        path: "/socket.io",
        withCredentials: true,
        transports: ["websocket", "polling"],
    });

    socket.on("connect", () => {
        console.log("✅ Socket connected:", socket.id);
        dispatch(setConnected({ socketId: socket.id }));

        // flush queued events
        const state = store.getState();
        const events = state.socket.pendingEvents;
        events.forEach(({ event, payload }) => {
            socket.emit(event, payload);
            console.log(`🚀 Flushed queued event: ${event}`);
        });
        dispatch(flushEvents());
    });

    socket.on("disconnect", () => {
        console.log("⚠️ Socket disconnected");
        dispatch(setDisconnected());
    });

    return socket;
};

export const closeSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};

export const getSocket = () => socket;
